var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomer = function SvgCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.4004H4.4C3.0744 16.4004 2 15.326 2 14.0004V4.40039H15.6C16.9256 4.40039 18 5.47479 18 6.80039V14.0004C18 15.326 16.9256 16.4004 15.6 16.4004Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6001 16.4003C7.6001 16.3079 7.6001 16.2161 7.6001 16.1003C7.6001 15.6035 7.2417 15.2003 6.8001 15.2003C6.3585 15.2003 6.0001 15.6035 6.0001 16.1003C6.0001 16.2161 6.0001 16.3079 6.0001 16.4003L7.6001 16.4003Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8003 16.4003C14.8003 16.3079 14.8003 16.2161 14.8003 16.1003C14.8003 15.6035 14.4419 15.2003 14.0003 15.2003C13.5587 15.2003 13.2003 15.6035 13.2003 16.1003C13.2003 16.2161 13.2003 16.3079 13.2003 16.4003L14.8003 16.4003Z",
    fill: "#C5C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40029 9.20037C7.28395 9.20037 8.00029 8.48402 8.00029 7.60037C8.00029 6.71671 7.28395 6.00037 6.40029 6.00037C5.51664 6.00037 4.80029 6.71671 4.80029 7.60037C4.80029 8.48402 5.51664 9.20037 6.40029 9.20037Z",
    fill: "#C5C5CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6001 12.8004C3.6001 11.254 4.8537 10.0004 6.4001 10.0004C7.9465 10.0004 9.2001 11.254 9.2001 12.8004V13.2004H3.6001V12.8004Z",
    fill: "#C5C5CA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8003,
    y: 8.40039,
    width: 5.6,
    height: 1.2,
    rx: 0.6,
    fill: "#C5C5CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8003,
    y: 10.0004,
    width: 5.6,
    height: 1.2,
    rx: 0.6,
    fill: "#C5C5CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8003,
    y: 11.6002,
    width: 5.6,
    height: 1.2,
    rx: 0.6,
    fill: "#C5C5CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 4.40037H2V3.60037C2 2.71637 2.716 2.00037 3.6 2.00037H7.2464C7.9352 2.00037 8.5464 2.44117 8.764 3.09477L9.2 4.40037Z",
    fill: "#C5C5CA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "customer.b0331ac9589ef9faf16e500862340ca4.svg";